import React, { ReactNode } from 'react'
import styled from 'styled-components'

const FloatWindowContainer = styled.div`
  position: fixed;
  bottom: 6rem;
  right: 2rem;
  width: 25rem;
  height: 31.25rem;
  background-color: ${({ theme }) => theme.forecast.pageBackground1};
  border: 1px solid ${({ theme }) => theme.forecast.border2};
  border-radius: 0.75rem;
  box-shadow:
    0 0.5rem 2rem 0 ${({ theme }) => theme.forecast.boxShadow},
    0 -0.5rem 2rem 0 ${({ theme }) => theme.forecast.boxShadow};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 999;
`

type FloatWindowProps = {
  children: ReactNode
}

export const FloatWindow: React.FC<FloatWindowProps> = ({ children }) => {
  return <FloatWindowContainer>{children}</FloatWindowContainer>
}
